import {MenuItemList} from '@yasc/yasc-material-components';


export const MENU_ITEMS: MenuItemList[] = [
    {
        prefix: "cp",
        name: "navCp",
        icon: "group",
        requiredPermission: "module_cp",
        _opened: false,
        hasMainPage: false,
        children: [
            {
                label: "sidebarHome",
                link: "/home"
            },
            {
                label: "sidebarProducts",
                link: "/product"
            },
            {
                label: "sidebarLicenceManagement",
                link: "/management",
                requiredPermission: "license:assign",
            },
        ]
    },
    {
        prefix: "crm",
        name: "navCrm",
        icon: "diversity_3",
        hasMainPage: false,
        requiredPermission: "module_crm",
        _opened: false,
        children: [
            {
                label: "navButtonProject",
                link: "/project",
                requiredPermission: "project:search"
            },
            {
                label: 'app_navigation_task_label',
                link: '/task',
                requiredPermission: "task:search"
            },
            {
                label: "navButtonTracker",
                link: "/acquisition"
            },
            {
                label: "navButtonWorkflow",
                link: "/workflow",
                requiredPermission: "workflow:search"
            },
            {
                label: 'navButtonCompany',
                link: '/company',
                requiredPermission: "company:search"
            },
            {
                label:'navButtonContacts',
                link: '/contacts'
            }
        ]
    },
    {
        prefix: "rm",
        requiredPermission: "module_rm",
        name: "navResources",
        icon: "calendar_month",
        hasMainPage: false,
        _opened: false,
        children: [
            {
                label: "navButtonHumanResources",
                link: "/humanResources"
            },
            {
                label: "navButtonProjectBudgets",
                link: "/project-budgets",
                requiredPermission: "project:stats"
            },
            {
                label: "app_navigation_timeManagement_label",
                link: "/timeTracker"
            },
            {
                label:"app_navigation_vacationManagement_label",
                link: "/vacation-management"
            },
            {
                label: "app_navigation_vacationApproval_label",
                link: "/approve",
            },
        ]
    },
    {
        prefix: "fibu",
        name: "navFibu",
        requiredPermission: "module_fibu",
        icon: "calculate",
        _opened: false,
        hasMainPage: false,
        children: [
            {
                label: "navFibBatchBooking",
                link: "/batchbooking",
                requiredPermission: "fibu:booking:search"
            },
            {
                label: "navFibJournal",
                link: "/journal",
                requiredPermission: "fibu:booking:search"
            },
            {
                label: "navFibRecurring",
                link: "/recurring",
                requiredPermission: "fibu:booking:search"
            },
            {
                label: "navFibTemplates",
                link: "/import-templates",
                requiredPermission: "fibu:booking:search"
            },
            {
                label: "navFibAccountPlan",
                link: "/account-plan",
                requiredPermission: "fibu:booking:search"
            },
            {
                label: "navFibExport",
                link: "/export",
                requiredPermission: "fibu:export"
            },
        ]
    },
    {
        prefix: "finances",
        name: "navFin",
        requiredPermission: "module_finances",
        icon: "account_balance",
        hasMainPage: false,
        _opened: false,
        children: [
            {
                label: "finBank",
                link: "/bank",
                requiredPermission: "fibu:bank:search"
            },
            {
                label: "finTransactions",
                link: "/transactions",
                requiredPermission: "fibu:transactions:search",
            }
        ]
    },
    // update starts here
    {
        prefix: "contracts",
        name: "navContracting",
        requiredPermission: "module_contracts",
        icon: "library_books",
        hasMainPage: false,
        _opened: false,
        children: [
            {
                label: "navContractAssignment",
                link: "/contract-assignment"
            },
            {
                label: "navLicenseAssignment",
                link: "/license-assignment",
                requiredPermission: "contracting_license_assignment:create",
            },
            {
                label: "navDeviceData",
                link: "/device-data",
                requiredPermission: "contracting_device_data:list"
            },
            {
                label: "navLicenseData",
                link: "/license-data",
                requiredPermission: "contracting_license_data:list"
            }
        ]
    },
    {
        prefix: "inventory",
        name: "navInventory",
        icon: "library_books",
        requiredPermission: "module_inventory",
        _opened: false,
        hasMainPage: true,
        children: [
            {
                label: "navArticle",
                link: "/article",
                requiredPermission: "inventory_article:list"
            },
            {
                label: "navComputer",
                link: "/computer",
                requiredPermission: "inventory_computer:list"
            },
            {
                label: "navDisplay",
                link: "/display",
                requiredPermission: "inventory_display:list"
            },
        ]
    },
];